// Mock Trust Tech Scan service. Replace with real API calls later.
let scans = {};

export function startScan(payload){
  const id = 'scan_' + Date.now();
  scans[id] = { id, status:'running', progress:0, startedAt: Date.now(), payload };
  return Promise.resolve({ id });
}

export function getScan(id){
  return Promise.resolve(scans[id]);
}

export function cancelScan(id){
  if(scans[id] && scans[id].status === 'running'){
    scans[id].status = 'cancelled';
  }
  return Promise.resolve(scans[id]);
}

function advance(){
  Object.values(scans).forEach(s=>{
    if(s.status === 'running'){
      s.progress = Math.min(100, s.progress + 10 + Math.random()*20);
      if(s.progress >= 100){
        s.progress = 100;
        s.status = 'completed';
        s.completedAt = Date.now();
        s.result = {
          suppliersAnalyzed: Math.floor(200 + Math.random()*150),
          issuesFound: Math.floor(Math.random()*25),
          optimizationOps: Math.floor(Math.random()*12)
        };
      }
    }
  });
  setTimeout(advance, 1500);
}
setTimeout(advance, 1500);
